import classNames from 'classnames'
import React from 'react'
import {Tooltip, Spinner} from 'wix-ui-tpa/cssVars'
import s from './form-button.scss'
import {classes} from './form-button.st.css'
import {FormButtonProps} from './interfaces'

export const FormButton: React.FC<FormButtonProps> = ({
  mobile,
  text,
  type = 'button',
  dataHook,
  width = '100%',
  disabled,
  onClick,
  previewTooltipText,
  spinner,
}) => {
  const content = spinner ? <Spinner className={classes.spinner} diameter={20} /> : text

  const buttonClasses = classNames(s.button, {
    [s.mobileButton]: mobile,
    [s.disabled]: disabled,
  })

  if (previewTooltipText) {
    return (
      <Tooltip content={previewTooltipText}>
        <button type="button" data-hook={dataHook} className={buttonClasses} style={{width}}>
          {content}
        </button>
      </Tooltip>
    )
  }

  return (
    <button
      data-hook={dataHook}
      className={buttonClasses}
      style={{width}}
      type={type}
      disabled={disabled}
      onClick={onClick}
    >
      {content}
    </button>
  )
}
